(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaos-reflective"] && !Shopify.designMode) return;
  try {
    
function initKaosVideos(){document.querySelectorAll('.kaos-video').forEach(video=>{if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.muted=true;video.play().catch(()=>{});}});}initKaosVideos();document.addEventListener('shopify:section:load',initKaosVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
